import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import { BalanceReportFilterValues } from 'pages/Finance/BalanceReport/BalanceReportList';
import qs from 'qs';
import { BalanceReport } from 'types/embedded/balanceReport';
import { getId } from 'utils';

export const getBalanceReport = async (
  filter: BalanceReportFilterValues,
): Promise<BalanceReport> => {
  const params = qs.stringify(
    {
      currency: filter.currency ? getId(filter.currency) : 1,
      conversionRateType: filter.conversionRateType,
      periodFrom: filter.periodFrom,
      periodTo: filter.periodTo,
      companies: filter.companies,
      merchants: filter.merchants,
      providers: filter.providers,
      merchantAccounts: filter.merchantAccounts,
      timezone: filter.timezone,
    },
    { arrayFormat: 'indices', encode: false },
  );
  return axios
    .get(`${Resources.BalanceReport}?${params}`, {
      headers: {
        Accept: 'application/ld+json',
      },
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
